import { render, staticRenderFns } from "./limitedConsumption.vue?vue&type=template&id=2742706e&scoped=true&"
import script from "./limitedConsumption.vue?vue&type=script&lang=js&"
export * from "./limitedConsumption.vue?vue&type=script&lang=js&"
import style0 from "./limitedConsumption.vue?vue&type=style&index=0&id=2742706e&prod&scoped=true&lang=css&"
import style1 from "./limitedConsumption.vue?vue&type=style&index=1&id=2742706e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2742706e",
  null
  
)

export default component.exports